import AmplifyActions from '/b2b/authentication/state/amplify/Amplify.actions';
import AuthActions from '/b2b/authentication/state/Auth.actions';
import { forgotPassword as ForgotPasswordService } from '/b2b/authentication/services';

export const onSendResetCode = params => dispatch => {
    dispatch(AuthActions.forgotPasswordBegin(params));
    return ForgotPasswordService(params)
        .then(resetPasswordOutput => {
            dispatch(AuthActions.forgotPasswordSuccess(params, resetPasswordOutput));
            return dispatch(AmplifyActions.nextStep(resetPasswordOutput));
        })
        .catch(error => {
            const { message } = error;
            dispatch(AuthActions.forgotPasswordFailure(params, message));
            throw message;
        });
};
